export default __webpack_public_path__ + "static/media/44.2845780a.png";